import React, {Component} from 'react';
import { connect } from 'react-redux';
import { 
  Layout,
  Spin, 
  Table, 
  Row, 
  Col, 
  Tag, 
  Button, 
  Tooltip, 
  Icon, 
  Form, 
  Modal, 
  Input, 
  Select, 
  Tabs, 
  Divider,
  PageHeader,
  Breadcrumb
} from 'antd';
import axios from 'axios';
import Moment from 'react-moment';
import qs from 'qs';
import { fetchMenuAction } from '../../store/actions/leftSideMenu';
import SearchForm from '../SearchForm';
import { Constant } from '../../config';
import MyModal from '../Modal';

const { Content } = Layout;
const ButtonGroup = Button.Group;
Moment.globalLocal = false;
const { TabPane } = Tabs;
const routes = () => [
  {
    path: "/",
    breadcrumbName: "Home",
  },
  {
    path: "/revision-price/listing",
    breadcrumbName: "Revision Price",
  },
  {
    path: "/country",
    breadcrumbName: "Country Listing",
  },
  {
    path: "",
    breadcrumbName: "Restrictions",
  },
];

class CountryRestrictions extends Component {
	state = {
		loading: false,
		dataSource: [],
		visibleFormModal: false,
    current_data: {},
    flagCreateOrUpdateForm: true, // true: created, false: updated
    countryData: []
	}

	columns = [
		{
			title: 'Country',
			dataIndex: 'region_code',
			render: (text, record)=>{
				let name = record.country_detail ? record.country_detail.name : text
				return (
					<span>
            <span style={{fontWeight:'bold'}}>{name}</span><br />
            <Tag color="blue">Code: {text}</Tag>
            <Tag color="orange">
              Last Update (UTC):
              <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm:ss">{record.updated}</Moment>
            </Tag>
          </span>
				)
			}
		},
		{
			title: 'Condition',
			dataIndex: 'condition_no',
			render: (text, record)=>{
				let conditionStr = "-"
				if (text === 1) {
					conditionStr = "This country-specific service conditions"
				}

				return conditionStr
			}
		},
		{
			title: 'Action',
			dataIndex: 'id',
			render: (text, record)=>{
    		return (
    			<ButtonGroup>
            <Tooltip placement="top" title="Edit">
              <Button icon="edit" onClick={()=>this._edit(record)} />
            </Tooltip>
            <Tooltip placement="top" title="Delete">
              <Button type="danger" icon="delete" onClick={()=>this._delete(text)} />
            </Tooltip>
          </ButtonGroup>
    		)
    	}
		}
  ]
  columnsMobile = [
    {
      title: 'Country',
      dataIndex: 'region_code',
      render: (text, record)=>{
        let name = record.country_detail ? record.country_detail.name : text
        let conditionStr = "-"
        if (record.condition_no === 1) {
          conditionStr = "This country-specific service conditions"
        }

        return (
          <span>
            <span style={{fontWeight:'bold'}}>{name}</span><br />
            <Tag color="blue">Code: {text}</Tag>
            <Tag color="orange">
              Last Update (UTC):
              <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm:ss">{record.updated}</Moment>
            </Tag>
            <Divider className="my-divider" dashed orientation="left">Condition</Divider>
            <div>{conditionStr}</div>
            <Divider className="my-divider" dashed orientation="left">Action</Divider>
            <Row>
              <ButtonGroup>
                <Tooltip placement="top" title="Edit">
                  <Button icon="edit" onClick={()=>this._edit(record)} />
                </Tooltip>
                <Tooltip placement="top" title="Delete">
                  <Button type="danger" icon="delete" onClick={()=>this._delete(text)} />
                </Tooltip>
              </ButtonGroup>
            </Row>
          </span>
        )
      }
    },
  ]
  currentPage = 1
  currentSearch = ""
  limit = 10
  totalRows = 0
  currentSmsType = "outbound"

	componentWillMount(){
    this.props.fetchMenuAction("country", "country-restrictions")
    this.setState({loading: true})
  }

  async componentDidMount() {
  	this.setState({
  		loading: false,
  		dataSource: await this._getList(1, 10, "", this.currentSmsType),
  	})
  }

  _create = async () => {
  	this.setState({
      current_data: {
      	id: 0,
      	region_code: undefined,
      	sms_type: this.currentSmsType,
      	condition_no: 1,
      },
      flagCreateOrUpdateForm: true,
      visibleFormModal: true,
      countryData: await this._getCountryList(this.currentSmsType)
    })
  }

  _edit = async (d) => {
  	this.setState({
      current_data: {
      	id: d.id,
      	region_code: d.region_code,
      	sms_type: d.sms_type,
      	condition_no: 1,
      },
      flagCreateOrUpdateForm: false,
      visibleFormModal: true,
      countryData: await this._getCountryList(this.currentSmsType, d.region_code)
    })
  }

  _delete = (id) => {
  	MyModal.confirm("คุณต้องการลบข้อจำกัดประเทศนี้ ใช่หรือไม่ ?", "", async (f)=>{
      if (!f)
        return

      let opt = {
        url: Constant.COUNTRY_RESTRICTIONS_EDIT_API.replace("[id]", id),
        method: "DELETE",
        headers: {
          'Authorization': "Bearer "+localStorage.getItem(Constant.SessionKey)
        }
      }
      let resp
      let modeTxt = "ลบ"
      let eMsg = `เกิดข้อผิดพลาด ไม่สามารถ${modeTxt}ข้อมูลได้ กรุณาลองใหม่อีกครั้ง`
      let eMsgDetail = ""
      let eFlag = false

      try {
        resp = await axios(opt)
      } catch(err) {
        resp = err.response
      }

      if (!resp.data) {
        eFlag = true
      } else if (resp.data.error) {
        eFlag = true
        let e = resp.data.error
        eMsgDetail = `[${e.code}] ${e.name}`
      }

      if (eFlag) {
        MyModal.error(eMsg, eMsgDetail, ()=>{
          window.location.reload()
        })
      } else {
        MyModal.info(`${modeTxt}ข้อมูลสำเร็จ`, "", async ()=>{
          this.setState({
            loading: false,
            dataSource: await this._getList(this.currentPage, this.limit, this.currentSearch, this.currentSmsType)
          })
        })
      }
    }, "ใช่", "ไม่ใช่")
  }

  formHandleSubmit = () => {
  	const { form } = this.formRef.props;

    form.validateFields(async (err, values) => {
      if (err)
        return

      this.setState({
        visibleFormModal: false,
        loading: true,
      })

      let url = Constant.COUNTRY_RESTRICTIONS_API
      if (!this.state.flagCreateOrUpdateForm)
      	url = Constant.COUNTRY_RESTRICTIONS_EDIT_API.replace("[id]", values.id)

      let opt = {
        url,
        method: (this.state.flagCreateOrUpdateForm ? "POST" : "PUT"),
        data: qs.stringify(values),
        headers: {
          'Authorization': "Bearer "+localStorage.getItem(Constant.SessionKey),
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }
      let resp
      let eMsg = `Something went wrong. Please try again.`
      let eMsgDetail = ""
      let eFlag = false

      try {
        resp = await axios(opt)
      } catch(err) {
        resp = err.response
      }

      if (!resp.data) {
        eFlag = true
      } else if (resp.data.error) {
        eFlag = true
        let e = resp.data.error
        eMsgDetail = `[${e.code}] ${e.name}`
      }

      if (eFlag) {
        MyModal.error(eMsg, eMsgDetail, ()=>{
          window.location.reload()
        })
      } else {
      	if (this.state.flagCreateOrUpdateForm)
        	form.resetFields()

        MyModal.info(`Restrictions has been ${this.state.flagCreateOrUpdateForm ? "created" : "updated"} successfully.`, "", async ()=>{
          this.setState({
            loading: false,
            dataSource: await this._getList(this.currentPage, this.limit, this.currentSearch, this.currentSmsType),
          })
        })
      }
    });
  }

  formHandleCancel = () => {
    this.setState({visibleFormModal: false})
  }

  saveFormRef = formRef => {
    this.formRef = formRef;
  };

  mySearch = (fd) => {
  	fd.validateFields(async (err, values)=>{
  		if (err)
  			return

      this.setState({loading: true})

	   	this.currentPage = 1
      this.currentSearch = values.searchTxt
      this.limit = 10
	    this.setState({
        dataSource: await this._getList(1, 10, this.currentSearch, this.currentSmsType),
        loading: false
      })
  	})
  }

  resetSearch = async () => {
    this.setState({loading: true})
  	this.currentPage = 1
    this.currentSearch = ""
  	this.setState({
      dataSource: await this._getList(1, 10, "", this.currentSmsType),
      loading: false
    })
  }

  changePage = async (page, limit) => {
    this.setState({loading: true})
  	this.currentPage = page
  	this.limit = limit
  	this.setState({
      dataSource: await this._getList(
        page,
        limit,
        this.currentSearch,
        this.currentSmsType
      ),
      loading: false
    })
  }

  _getList = async (page=1, limit=10, search="", smsType)=>{
  	let url = Constant.COUNTRY_RESTRICTIONS_API+"?page="+page+"&limit="+limit+"&search="+search+"&sms_type="+smsType

    let opt = {
      url,
      method: "GET",
      headers: {
        'Authorization': "Bearer "+localStorage.getItem(Constant.SessionKey)
      },
    }
    let resp

    try {
      resp = await axios(opt)
    } catch(err) {
      resp = err.response
    }

    if (!resp.data){
      console.log(resp.data)
      return []
    }

    if (resp.data.error) {
      console.log(resp.data.error)
      return []
    }

    this.totalRows = resp.data.total_rows || 0

    return resp.data.data
  }

  _getCountryList = async (smsType="", myRegionCode="")=>{
  	let url = Constant.COUNTRY_API+"?limit=0&sms_type="+smsType+"&my_region_code="+myRegionCode

    let opt = {
      url,
      method: "GET",
      headers: {
        'Authorization': "Bearer "+localStorage.getItem(Constant.SessionKey)
      },
    }
    let resp

    try {
      resp = await axios(opt)
    } catch(err) {
      resp = err.response
    }

    if (!resp.data){
      console.log(resp.data)
      return []
    }

    if (resp.data.error) {
      console.log(resp.data.error)
      return []
    }

    return resp.data.data
  }

  tabsChange = (key)=>{
  	this.currentSmsType = key
  	this.child.clearTxtSearch()
  	this.resetSearch()
  }

	render() {
    let propsTable = {
      className: "my-table",
      columns: this.columns,
      dataSource: this.state.dataSource,
      rowKey: "id",
      pagination: {
        pageSize:this.limit, 
        total:this.totalRows, 
        current:this.currentPage, 
        onChange:this.changePage, 
        size:"small"
      }
    }
    let propsTableForMobile = Object.assign({}, propsTable)
    propsTableForMobile.className = "my-table-mobile"
    propsTableForMobile.columns = this.columnsMobile

		return (
      <Layout>
        <Breadcrumb className="breadcrumb">
          {routes(this.state.versionString).map((route) => (
            <Breadcrumb.Item>
              {route.path ? (
                <a href={route.path}>{route.breadcrumbName}</a>
              ) : (
                route.breadcrumbName
              )}
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
        <PageHeader
          style={{
            backgroundColor: "#f0f2f5",
          }}
          title={<h2 style={{ fontWeight: "bold" }}>Restrictions</h2>} />
        <div className="my-layout">
          <Spin spinning={this.state.loading} tip="Loading...">
            <Content className="main-container">
              <div className='main-container-inner'>
                <Row className="utility-bar">
                  <Col span={12}><Button onClick={()=>this._create()}><Icon type="plus-circle" />Add</Button></Col>
                  <Col span={12}><SearchForm fn={this.mySearch} fnReset={this.resetSearch} onRef={ref => (this.child = ref)} /></Col>
                </Row>
                <Row className="utility-bar-mobile">
                  <Button block onClick={()=>this._create()}><Icon type="plus-circle" />Add</Button>
                </Row>
                <Row className="utility-bar-mobile">
                  <SearchForm fn={this.mySearch} fnReset={this.resetSearch} onRef={ref => (this.child = ref)} />
                </Row>
              </div>
              <Tabs defaultActiveKey={this.currentSmsType} onChange={this.tabsChange}>
                <TabPane tab="SMS" key="outbound">
                  <Table {...propsTable} />
                  <Table {...propsTableForMobile} />
                </TabPane>
                {/* <TabPane tab="VERIFY" key="verify">
                  <Table {...propsTable} />
                  <Table {...propsTableForMobile} />
                </TabPane> */}
              </Tabs>

            </Content>
          </Spin>
          <CountryRestrictionsForm
            wrappedComponentRef={this.saveFormRef}
            visible={this.state.visibleFormModal}
            onCancel={this.formHandleCancel}
            onCreate={this.formHandleSubmit}
            data={this.state.current_data}
            flagCreateOrUpdateForm={this.state.flagCreateOrUpdateForm}
            countryData={this.state.countryData}
          />
        </div>
      </Layout>
		)
	}
}

const CountryRestrictionsForm = Form.create({name: "country_restrictions_form"})(
	class extends Component {
		componentDidUpdate = async (prevProps, prevState) => {
      const {data: pd} = prevProps
      const {data: d, form} = this.props

      if (d && (d.region_code !== pd.region_code || d.sms_type !== pd.sms_type)) {
      	form.setFieldsValue(d)
      }
    }

    render() {
    	const { visible, onCreate, onCancel, form, flagCreateOrUpdateForm, countryData } = this.props;
      const { getFieldDecorator } = form;

      let okText = (flagCreateOrUpdateForm ? "Add" : "Edit")
      let title = okText+" Restrictions"

      return (
      	<Modal
          visible={visible}
          title={title}
          okText={okText}
          cancelText="Cancel"
          onCancel={onCancel}
          onOk={onCreate}
          maskClosable={false}
          style={{ top: 20 }}
        >
          <Form layout="vertical" className="verify_template_form">
            {getFieldDecorator('id')(<Input type="hidden" />)}
            <Form.Item label="Country">
		          {getFieldDecorator('region_code', {
		            rules: [{ required: true, message: 'Country is required' }],
		          })(
		            <Select placeholder="Select Country">
		            	{countryData.map((v, i)=> <Select.Option key={v.id} value={v.region_code}>{v.name}</Select.Option> )}
		            </Select>
		          )}
		        </Form.Item>
		        <Form.Item label="SMS Type">
		          {getFieldDecorator('sms_type', {
		            rules: [{ required: true, message: 'SMS Type is required' }],
		          })(
		            <Select placeholder="SMS Type">
		              <Select.Option value="outbound">SMS</Select.Option>
		              {/* <Select.Option value="verify">VERIFY</Select.Option> */}
		            </Select>
		          )}
		        </Form.Item>
            {getFieldDecorator('condition_no')(<Input type="hidden" />)}
          </Form>
        </Modal>
      )
    }
	}
);

const mapDispatchToProps = dispatch => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) => dispatch(fetchMenuAction(menuParentKey, menuKey)),
  }
}

export default connect(null, mapDispatchToProps)(CountryRestrictions)


// WEBPACK FOOTER //
// ./src/containers/Country/CountryRestrictions.js